import { useCallback } from 'react';
import useCartItems from './useCartItems';

const useProductQuantities = () => {
    const cartItems = useCartItems();

    const getQuantityForSku = useCallback(
        (sku: string): number | undefined => {
            return cartItems.find(item => item.sku === sku)?.quantity;
        },
        [cartItems]
    );

    return {
        getQuantityForSku,
    };
};

export default useProductQuantities;
